import {
  RECEIVE_USERINFO,
  GET_USER_MENU_PERMS,
  GET_OA_WAITCOUNT,
  GET_TOOLTIP_INFO,
  GET_COMPARE_LIST,
  GET_USER_ORGS
} from "./mutation-types";

export default {
  [RECEIVE_USERINFO] (state, { user }) {
    state.usergetUserInfo = user;
  },
  //菜单权限目录获取
  [GET_USER_MENU_PERMS] (state, { menu }) {
    state.menuPerms = menu.perms;
    state.menuChild = menu.menus
  },
  [GET_OA_WAITCOUNT] (state, count) {
    state.OAWaitCount = count
  },
  [GET_TOOLTIP_INFO] (state, data) {
    state.tooltipData = data
  },
  [GET_USER_ORGS](state, data) {
    state.userOrgs = data
  }
};



// WEBPACK FOOTER //
// ./src/store/mutations.js